// React and related imports
import React from 'react';

// Translation and i18n setup
import { useTranslation } from 'react-i18next';

export const LogoText: React.FC = () => {
  const { t } = useTranslation();

  return (
    <span className="logo-text ms-2 self-center whitespace-nowrap text-xl font-semibold text-black">
      {t('header.appName')}
    </span>
  );
};
